import HtmlSanitizer from './HtmlSanitizer';
import HtmlSanitizerConfig from './HtmlSanitizer.config';

export const htmlSanitizer = new HtmlSanitizer(HtmlSanitizerConfig);
